import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  getBiller,
  createCheckout,
  requestPay,
  getBillerPrefix,
  getBillerRecentTrx,
  getLatestTNC,
  getAgreementTNC,
  signatureAgreementTNC,
} from 'redux/actions/BillerAction';

import {
  getForm,
  updateFieldForm,
  setFormDataValue,
} from 'redux/actions/FormAction';

import { setLoading, setErrorState } from 'redux/actions/GeneralAction';
import { trackEvent } from 'utils/Mixpanel';
import { injectIntl } from 'react-intl';
import GeneralFormPage from './GeneralFormPage.page';

const page = injectIntl(GeneralFormPage);

const mapStateToProps = state => ({
  deviceHeight: state.general.deviceHeight,
  biller: state.biller.biller,
  checkout: state.biller.checkout,
  checkoutParam: state.biller.checkoutParam,
  isLoading: state.general.isLoading,
  formData: state.formData.form,
  formValue: getFormValues('allBiller')(state),
  selectedPaymentMethod: state.formData.selectedPaymentMethod,
  isTncAgreed: state.formData.tnc.isAgreed,
  additionalInfo: state.general.additionalInfo,
});

const mapDispatchToProps = {
  getBiller,
  getForm,
  setLoading,
  createCheckout,
  requestPay,
  getBillerPrefix,
  getBillerRecentTrx,
  setErrorState,
  updateFieldForm,
  trackEvent,
  setFormDataValue,
  getLatestTNC,
  getAgreementTNC,
  signatureAgreementTNC,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(page);
